import { Environment } from '@nimmsta/ng-commons-lib/config';

export const environment = {
  production: false,
  environment: Environment.STAGING,
  apiUrls: {
    b2b: 'https://backend.staging.b2b.nimmsta-test.de',
    workflow: 'https://backend.staging.cloud.nimmsta-test.de',
    configurations: 'https://backend.staging.configurator.nimmsta-test.de',
    auth: 'https://auth.staging.nimmsta-test.de',
  },
  applicationUrls: {
    workflow: 'https://staging.cloud.nimmsta-test.de',
    configurations: 'https://staging.configurator.nimmsta-test.de',
  },
  defaultPageSize: 20,
  defaultPageSizeOptions: [10, 20, 50, 100],
  keycloakUrl: 'https://auth.staging.nimmsta-test.de',
  keycloakRealm: 'productivity-cloud',
  keycloakClientId: 'platform',
  ncsTicketUrl: 'https://nimmsta.atlassian.net/browse',
  USER_KEY: 'user_object',
  defaultConfigurationVersion: 7,
};
